import { render } from "./AppHero.vue?vue&type=template&id=46765514"
import script from "./AppHero.vue?vue&type=script&lang=ts"
export * from "./AppHero.vue?vue&type=script&lang=ts"

import "./AppHero.vue?vue&type=style&index=0&id=46765514&lang=scss"
script.render = render

export default script